import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
import { getTestimonials } from "../Service/Api";
const s3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/"
const StudentBlog = () => {
  const [blogs, setBlogs] = useState([]);


  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await getTestimonials();

        const list = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : [];

        setBlogs(list);
      } catch (error) {
        console.error("Error fetching student blogs:", error);
        setBlogs([]);
      }
    };

    fetchBlogs();
  }, []);

  const getImage = (img) => {
    if (!img) return "";
    return img.startsWith("http") ? img : img;
  };

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Activity</li>
          <li>Student Blog</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Student Blog</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {blogs.map((item, index) => (
                <div className="blogbox" key={item?._id || index}>

                  <div className="blogboximg">
                    <LazyLoad>
                      <img
                        src={`${s3_url}${getImage(item?.image?.[0] || item?.attachments?.[0])}`}
                        className="img-fluid"
                        alt=""
                      />
                    </LazyLoad>
                  </div>

                  <div className="blogboxdesc">
                    <h6>{item?.title || item?.heading}</h6>

                    <div className="blogboxmsg">
                      <p
                        dangerouslySetInnerHTML={{
                          __html: item?.description || item?.text || "",
                        }}
                      />
                    </div>

                    <div className="blogboxinfo">
                      <p className="blogname">
                        {item?.name}
                        <span> {item?.designation}</span>
                      </p>

                      {/* <p className="blogdate">
                        Date :{" "}
                        {item?.date
                          ? new Date(item.date).toLocaleDateString("en-GB")
                          : ""}
                      </p> */}
                    </div>

                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentBlog;